module.exports = __webpack_public_path__ + "static/media/equipment.e33dbc85.svg";